module.exports = __webpack_public_path__ + "img/login-illustration.ba241ab4.svg";